export const BRAND_NAME = 'Jadu';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'jadu.live';
export const PROVIDER_ID = 'BetFair';
